// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3titQ","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1flhl","obliqueLine":"membershipbadge_obliqueLine__mldbB"};